module.exports = __webpack_public_path__ + "files/blackboard_results_sample.e975f667.csv";